export const ACC_GEOLOCATIONS_MAP: Record<string, string> = {
  '301': 'Far North District',
  '302': 'Whangarei District',
  '303': 'Kaipara District',
  '304': 'Rodney District',
  '305': 'North Shore City',
  '306': 'Waitakere City',
  '307': 'Auckland City',
  '308': 'Manukau City',
  '309': 'Papakura District',
  '310': 'Franklin District',
  '311': 'Thames-coromandel-district',
  '312': 'Hauraki District',
  '313': 'Waikato Distrist',
  '315': 'Matamata Piako District',
  '316': 'Hamilton City',
  '317': 'Waipa District',
  '318': 'Otorohanga District',
  '319': 'South Waikato District',
  '320': 'Waitomo District',
  '321': 'Taupo District',
  '322': 'Western Bay Of Plenty District',
  '323': 'Tauranga District',
  '324': 'Rotorua District',
  '325': 'Whakatane District',
  '326': 'Kawerau District',
  '327': 'Opotiki District',
  '328': 'Gisborne District',
  '329': 'Wairoa District',
  '330': 'Hastings District',
  '331': 'Napier City',
  '332': 'Central Hawkes Bay District',
  '333': 'New Plymouth District',
  '334': 'Stratford District',
  '335': 'South Taranaki District',
  '336': 'Ruapehu District',
  '337': 'Wanganui District',
  '338': 'Rangitikei District',
  '339': 'Manawatu District',
  '340': 'Palmerston North City',
  '341': 'Tararua District',
  '342': 'Horowhenua District',
  '343': 'Kapiti Coast District',
  '344': 'Porirua City',
  '345': 'Upper Hutt City',
  '346': 'Lower Hutt City',
  '347': 'Wellington City',
  '348': 'Masterton District',
  '349': 'Carterton District',
  '350': 'South Wairarapa District',
  '351': 'Tasman District',
  '352': 'Nelson City',
  '353': 'Marlborough District',
  '354': 'Kaikoura District',
  '355': 'Buller District',
  '356': 'Grey District',
  '357': 'Westland District',
  '358': 'Hurunui District',
  '359': 'Waimakariri District',
  '360': 'Christchurch City',
  '361': 'Banks Peninsula District',
  '362': 'Selwyn District',
  '363': 'Ashburton District',
  '364': 'Timaru District',
  '365': 'Mckenzie District',
  '366': 'Waimate District',
  '367': 'Chatham Island Country',
  '368': 'Waitaki District',
  '369': 'Central Otago District',
  '370': 'Queenstown Lakes District',
  '371': 'Dunedin City',
  '372': 'Clutha District',
  '373': 'Southland District',
  '374': 'Gore District',
  '375': 'Invercargill City',
  '390': 'At Sea, Not in NZ Waters',
  '391': 'Overseas',
  '392': 'In the Air - N.Z',
  '393': 'In the Air - Overseas',
  '394': 'In NZ Waters',
  '991': 'At Sea',
  '992': 'Overseas',
  '993': 'Not Obtainable',
  '994': 'In the Air - Overseas',
  '995': 'Not Obtainable',
  '998': 'Other Islands',
  '999': 'Not Obtainable',
};
export type AccGeoLocationCode = keyof typeof ACC_GEOLOCATIONS_MAP;

export const ACC_SCENE_MAP: Record<string, string> = {
  '50': 'Commercial Or Service Location',
  '20': 'Farm',
  '10': 'Home',
  '40': 'Industrial Place',
  '80': 'Place Of Medical Treatment',
  '70': 'Place Of Recreation Or Sports',
  '30': 'Road Or Street',
  '60': 'School',
  '90': 'Other',
  '99': 'Not Obtainable',
};
export type AccSceneCode = keyof typeof ACC_SCENE_MAP;

export const ACC_SPORTS_MAP: Record<string, string> = {
  '50': 'Aerobics',
  '51': 'Athletics',
  '100': 'ATV',
  '52': 'Badminton',
  '53': 'Basketball',
  '54': 'Boating',
  '55': 'Bowls',
  '111': 'Boxing',
  '56': 'Bungee Jumping',
  '59': 'Cycling',
  '60': 'Dancing',
  '61': 'Fishing',
  '106': 'Fitness Training / Gym',
  '62': 'Golf',
  '63': 'Gymnastics',
  '64': 'Hang-gliding',
  '65': 'Hockey',
  '66': 'Horse Riding',
  '67': 'Hunting',
  '68': 'Ice Skating',
  '57': 'Indoor Cricket',
  '69': 'Jogging',
  '102': 'Kayaking',
  '112': 'Kick-boxing',
  '70': 'Luge Riding',
  '71': 'Martial Arts',
  '73': 'Motor Racing',
  '72': 'Motorcycling',
  '74': 'Mountaineering',
  '75': 'Netball',
  '58': 'Outdoor Cricket',
  '76': 'Parachute Jumping',
  '77': 'Polo',
  '103': 'Rock Climbing',
  '78': 'Roller Skating',
  '105': 'Rollerblading',
  '80': 'Rugby League',
  '79': 'Rugby Union',
  '104': 'Scooter',
  '81': 'Skateboarding',
  '82': 'Skiing - Snow',
  '101': 'Snowboarding',
  '83': 'Soccer',
  '84': 'Softball, Baseball',
  '85': 'Squash',
  '86': 'Surfing',
  '87': 'Swimming',
  '108': 'Swimming - Beach',
  '110': 'Swimming - Lake',
  '107': 'Swimming - Pool',
  '109': 'Swimming - River',
  '88': 'Tennis',
  '97': 'Touch Rugby',
  '89': 'Trail Biking, Motocross',
  '96': 'Tramping',
  '91': 'Underwater Diving',
  '92': 'Volleyball',
  '93': 'Waterskiing',
  '94': 'Weightlifting',
  '95': 'Windsurfing',
  '90': 'Other',
  '99': 'Not Obtainable',
};
export type AccSportsCode = keyof typeof ACC_SPORTS_MAP;

export const ACC_REHABILITATION_MAP: Record<string, string> = {
  '1': 'No need for ACC to call Health Provider',
  '4': 'ACC to call Health Provider',
};
export type AccRehabilitationCode = keyof typeof ACC_REHABILITATION_MAP;

export const ACC_REHABILITATION_DISPLAY_MAP: Record<string, string> = {
  '1': 'No',
  '4': 'Yes',
};

export const OTHER_ETHNICITY_CODE = '54';
export const ACC_ETHNICITY_MAP: Record<string, string> = {
  '53': 'African',
  '40': 'Asian not further defined',
  '42': 'Chinese',
  '32': 'Cook Island Maori',
  '10': 'European not further defined',
  '36': 'Fijian',
  '43': 'Indian',
  '52': 'Latin American / Hispanic',
  '51': 'Middle Eastern',
  '34': 'Niuean',
  '11': 'NZ European / Pakeha',
  '21': 'NZ Maori',
  '44': 'Other Asian',
  '12': 'Other European',
  '37': 'Other Pacific Island',
  '30': 'Pacific Island not further defined',
  '31': 'Samoan',
  '41': 'Southeast Asian',
  '35': 'Tokelauan',
  '33': 'Tongan',
  [OTHER_ETHNICITY_CODE]: 'Other',
  '61': 'Other Ethnicity',
  '99': 'Not stated',
  '94': `Don't Know`,
  '0': 'Declined to answer',
  '95': 'Refused to Answer',
  '97': 'Response Unidentifiable',
};
export type AccEthnicityCode = keyof typeof ACC_ETHNICITY_MAP;

export const ACC_DENTIST_PROVIDER_TYPE = '82'; // Dentist
export const ACC_PROVIDER_TYPE_MAP: Record<string, string> = {
  '38': 'Accident And Emergency (Contract)',
  '79': 'Acupuncturist',
  '55': 'Ambulance Driver (Contracts)',
  '13': 'Anaesthetist',
  '87': 'Audiologist',
  '30': 'Cardiothoraric Surgeon',
  '86': 'Chiropractor',
  '18': 'Community Medicine',
  '90': 'Counsellor',
  '37': 'Dental Specialist',
  '50': 'Dental Technicians',
  [ACC_DENTIST_PROVIDER_TYPE]: 'Dentist',
  '14': 'Dermatologist',
  '57': 'District Nurse',
  '36': 'Dummy Class Prev Deleted',
  '71': 'Elective Services (Contracts)',
  '41': 'G.P. Receiving Rural Bonus',
  '5': 'General Medicine',
  '80': 'General Practitioner',
  '31': 'General Surgeon',
  '58': 'Hand Therapy - Physio (Contract',
  '19': 'High Tech Radiology (Contract)',
  '83': 'Hospital',
  '54': 'Laboratory Technicians',
  '51': 'Medical Radiation Technologists',
  '32': 'Neurosurgeon',
  '52': 'Nurses (Other)',
  '23': 'Obstetrician & Gynaecologist',
  '77': 'Occupational Therapist',
  '24': 'Ophthamologist',
  '53': 'Optometrists',
  '25': 'Orthopaedic Surgeon',
  '78': 'Osteopaths',
  '76': 'Other Counsellor',
  '1': 'Other Specialists',
  '26': 'Otolaryngologist',
  '33': 'Paediatric Surgeon',
  '27': 'Paediatrician',
  '16': 'Pathologist',
  '81': 'Physiotherapist',
  '34': 'Plastic Surgeon',
  '85': 'Podiatrist',
  '56': 'Practice Nurse',
  '84': 'Prescription Charges',
  '73': 'Prime Gp (Contract)',
  '17': 'Psychiatrist',
  '93': 'Psychologist',
  '94': 'Psychotherapist',
  '20': 'Radiologist',
  '28': 'Radiotherapist',
  '39': 'Rural Nurses (Contract)',
  '92': 'Speech Therapist',
  '72': 'Transport/Accom-Elective (Contract)',
  '35': 'Urologist',
  '29': 'Venereologist',
};
export type AccProviderTypeCode = keyof typeof ACC_PROVIDER_TYPE_MAP;

export const ACC_EMPLOYED_VALUE = '1';
export const ACC_SELF_EMPLOYED_VALUE = '3';
export const ACC_OTHER_EMPLOYED_VALUE = '5';
export const ACC_EMPLOYMENT_STATUS_MAP: Record<string, string> = {
  [ACC_EMPLOYED_VALUE]: 'I am an Employee',
  '11': 'I own/part own the company in which I work',
  [ACC_SELF_EMPLOYED_VALUE]: 'I am self-employed',
  [ACC_OTHER_EMPLOYED_VALUE]: 'Other',
};
export type AccEmploymentStatusCode = keyof typeof ACC_EMPLOYMENT_STATUS_MAP;

export const ACC_WORK_TYPE_MAP: Record<string, string> = {
  '1': 'Sedentary (i.e. sitting)',
  '2': 'Light',
  '3': 'Medium',
  '4': 'Heavy',
  '5': 'Very Heavy',
};
export type AccWorkTypeCode = keyof typeof ACC_WORK_TYPE_MAP;

export const ACC_OCCUPATION_CODE_UNEMPLOYED = '9996';
export const ACC_OCCUPATION_MAP: Record<string, string> = {
  '2411': `Accountant; Audit,Financial,Consultant : Auditor,Chartered,Company,Cost,Bank`,
  '4121': `Accounting, Bookkeeping Clerk; Accounts : Bookkeeping,Meter Reader,Rates,Payments`,
  '3321': `Admin Or Related Associate Prof; Sales : Functions,Coordinator,Facilities,Office`,
  '1225': `Advertising & Public Relations Mgr; : Public Affairs,Company Promoter,Agency`,
  '3212': `Agricultral Technician; Animal,Forest : Park,Seed,Research,Soil,Plant,Botany`,
  '2213': `Agricultural Scientist; Soil,Farm,Crop : Animal Husbandry,Forestry,Conservation`,
  '3144': `Air Traffic Controller; Aerodrome : Airline,Radar,Airport`,
  '3143': `Aircraft Pilot Or Related Worker; Flight : Crew,Airline,Bolloonist,Aerial,Captain`,
  '6144': `Animal Welfare Worker; Animal Control,Dog : Aquarim,Aviary,Kennel,Cattery,Zoo,Pet`,
  '6124': `Apiarist; Apiary Worker, Bee : Beekeeper,Honey Grader,Worker Bee`,
  '3317': `Appraiser, Valuer; Valuation Officer : Land,Registered,Antique,Commerical`,
  '6142': `Aquatic Life Cultivation Worker; Hatchery : Fish Farm,Mussel,Oyster,Salmon,Shellfish`,
  '2141': `Architect,town Or Traffic Planner; Urban : Resource Management,Landscape,building`,
  '2431': `Archivist, Curator; Museum,Film : Document Restorer,Art Conservator`,
  '5155': `Armed Forces; Air Force,Airman,Artillery : Naval,Navy,Soldier,Army,Officer,Pilot`,
  '3369': `Athlete Or Related Worker; Aerobics,Coach : Cricketer,Jockey,Gym,Referee,Ski,Rugby`,
  '3318': `Auctioneer; Furniture,Livestock : Real Estate,Stock,Wool`,
  '3361': `Author,journalist Or Other Writer; Writer : Editor,Reviewer,Critic,Media,Literary`,
  '8274': `Baked Goods, Cereals Prod Mach Op; Bakery : Animal Food,Pasta,Ovenman,Bakehouse`,
  '7412': `Baker; Cake, Pastry,Biscuit, : Food,Cook,Bread,Cake Decorator`,
  '2421': `Barrister & Solicitor; Attorney,Lawyer : Conveyance,Legal Advocate,Notary,`,
  '4215': `Bill,debt Or Rel. Cash Collector; Bailiff : Rate,Rent,Repossesion Agent,Repossessor`,
  '7332': `Binding Trades Worker; Binder,Bindery : Embosser,Repairer,Book`,
  '2211': `Biologist, Botanist, Zoologist; Ecologist : Silviculturist,Marine,Plant,Animal,Crop`,
  '7221': `Blacksmith; Striker,Farrier, : Wrought Iron,Shoeing`,
  '3323': `Bookkeeper; Accounts,Ledger,Book :`,
  '8279': `Brewer, Wine & Beverage Mach Op; Brewer : Beer,Distiller,Winery,Alcoholic,Liquor`,
  '7111': `Bricklayer, Stonemason; Artificial Stone : Marble,Masonary,Stone,Tile,Polishing`,
  '3132': `Broadcasting Equip. Controller; Operator : Film,Lighting,Radio,Communications,Edit`,
  '8411': `Building Or Related Worker; Aluminium : Construction,Drain,Roof,Steel,Cable`,
  '8322': `Bus Driver; Coach,Tour,Trolley Bus,Tram : School Bus,Passenger,Tour Operator`,
  '7411': `Butcher; Wholesale,Retail,Meat Grader :`,
  '3316': `Buyer; Company,Livestock,Print,Produce : Wholesale,Retail,Wool,Purchasing Agent`,
  '7421': `Cabinet Maker Or Related Worker; Antique : Coffin,Furniture,Picture,Veneer,Wood`,
  '8321': `Car, Taxi, Light Van Driver; Chauffeur : Shuttle,Storeperson,Driving Instructor`,
  '3351': `Careers & Employment Advisor; Counsellor : Occupation Guidance,Placement,Vocational`,
  '9111': `Caretaker, Cleaner; Vehicles,Buildings : Dishes,Window,Pest Control,General`,
  '7112': `Carpenter & Joiner; Boatbuilding,Builder : Bridge,Wood,Shopfitter,Wharf`,
  '2148': `Cartographer, Surveyor; Land,Facilities, : Photographic,Marine,Mines,Hydro,Geodetic`,
  '4211': `Cashier, Ticket Issuer; Checkout,Betting : Lotto,Pool,Parking,TAB,Skating Rink`,
  '8212': `Cement & Other Processing Mach Op; : Concrete,Pile,Post,Pipe,Precast`,
  '2146': `Chemical Engineer; Petroleum,Oil,Gas : Food Technologist,Biotechnologist,`,
  '3116': `Chemical Engineering Technician; Gas,Food : Dairy,Fuel,Wool,Petroleum,Oil`,
  '2113': `Chemist; Organic,Pharmaceutical,Polymer : Industrial,Paint Technologist,Nuclear`,
  '5142': `Child Care Worker; Babysitter,Minder : Nanny,Nursemaid,Nursery`,
  '3365': `Choreographer, Dancer; Ballet,Dancer : Teacher,Modern Dance,Classical,Dance`,
  '2142': `Civil Engineer; Construction,Water,Hydro : Railway,Road,Drainage,Building,Stuctural`,
  '3112': `Civil Engineering Technician; Building : Construction,Quantity,Waste Water`,
  '3368': `Clown, Magician Or Rel. Worker; Comedian : Circus,Acrobat,Puppet,Hypontist,Stripper`,
  '4143': `Coding,proof Reading Or Rel. Clerk; : Proof Reader,Readers Assistant`,
  '3364': `Composer, Musician, Singer; Accompanist : Compose,Conductor,Singer,Orchestra,Music`,
  '3121': `Computer Equipment Controller; Tester : Programmer,Web,Systems,Applications`,
  '2131': `Computing Professional; Systems Architect : Ecommerce,Programmer,Analyst,Internet`,
  '1227': `Computing Services Manager; IT,EDP,TSS : Data Processing,Information Technology`,
  '5122': `Cook; Cafe,Chef,Sous,Short Order,Fastfood : Restaurant,Hotel,Ship,`,
  '1211': `Corporate Mgr Or Managing Director; Chief : Company,General,Business,Service,Area`,
  '2445': `Counsellor; Alcohol,Marriage Guidance : Family,Sexual Abuse,Personal,Vocational`,
  '8333': `Crane Operator; Derrick,Elevator,Jib : Hoist,Mobile Crane,Tower Crane, Winch`,
  '6125': `Crop & Livestock Producer; Farm,Grubber : Willow,Tussock,Station,Mixed,Farmer`,
  '4213': `Croupier; Casino Supervisor,Gaming Dealer : Gaming Table Supervisor, Pit Boss`,
  '8151': `Crushing,grinding,mixing Equip. Op; Glass : Chemical,Fertilisers,Starch Mill`,
  '3331': `Customs & Border Inspector; Biosecurity : Bond,Quarantine,Immigration,Border`,
  '8272': `Dairy Products Machine Operator; Cheese : Butter,Ice Cream,Milk,Pasteurising`,
  '4112': `Data Entry Operator; Coding Clerk : Keyboard,Teleprompt,Visual Display`,
  '3363': `Decorator, Commercial Designer; Animator : Advertising,Carpet,Display,Web,Clothing`,
  '3222': `Dental Assistant; Oral,Gum,Nurse : Hygienist,Therapist,Tutor`,
  '2222': `Dentist; Oral,Surgeon,Orthodontist,Dental : Prosthodontist,Periodontist,Paedodontist`,
  '2225': `Dietitian, Pub.health Nutritionist; : Dietician,Hospital,Clincial,Community`,
  '3118': `Draughting Technician; Architectural,CAD : Computer,Design,Photographic,Structural`,
  '2332': `Early Childhood Teaching Prof; Playcentre : Kohanga Reo,Kindergarten,Preschool,`,
  '8332': `Earthmoving Or Rel. Machinery Op; Asphalt : Bulldozer,Driller,Paving,Trench,Road`,
  '2441': `Economist; Financial Analyst Broker : Forecaster,Research,Finance Analyst`,
  '2351': `Education Advisor; School,Preschool,Arts : Curriculum,Specialist,Government`,
  '3342': `Education Associate Professional; Tutor : Teachers Aide,Access Teacher`,
  '2352': `Education Reviewer; School Inspector : Education Review Officer`,
  '2143': `Electrical Engineer; Industrial : Power Systems,Transmission,Automotive`,
  '3113': `Electrical Engineering Technician; Power : Transmission,Quality,Generation,Test`,
  '8292': `Electrical Machinery Assembler; Cable : Power,Transformer,Telephone,Linesperson`,
  '7241': `Electrical Mechanic & Fitter; Dynamo,Lift : Fire Alarm,Elevator,Signal System`,
  '7131': `Electrician; Appliance,Automotive : Domestic,Repairman,Lighting,Aircraft`,
  '2144': `Electronic & Telecomm. Engineer; Radio : Fibre Optics,Television,Satellite`,
  '3114': `Electronic Engineering Technician; Radio : Avionics,Computer,Quality,Telecom,TV`,
  '7242': `Electronics Fitter & Servicer; Avionics : Alarm,Photocopier,Reprographic,Security`,
  '3381': `Environment Protection Assoc. Prof; : Acclimatisation,Beach,Fish and Game,Park`,
  '5231': `Fashion Or Other Model; Artists Model : Model,Instructor,Photograpic`,
  '6111': `Field Crop, Vegetable Grower; Arable,Crop : Flax,Hop,Maize,Farmer,Grower,Vegetable`,
  '3366': `Film,stage Or Rel.actor Or Directr; Actor : Director,Producer,Stage,Radio,Stunt`,
  '8152': `Filtering & Separating Equip. Op; Water : Filtering,Chemicals,Waterworks,`,
  '1222': `Finance & Administration Manager; Bank : Department,Branch,Accounting,Insurance`,
  '5151': `Fire Fighter; Aircraft,Accident,Crash : Airport,Fire,Resuce,Rural,Fireman`,
  '6141': `Fishery Worker; Fisherman,Fish,Diver, : Oyster,Paua,Trawler Man,Shell Fish`,
  '7223': `Fitter & Turner; Auto,Factory,Metal : Petrol,Waterworks,`,
  '7433': `Floor Covering Layer; Carpet Layer,Sander : Linoleum,Vinyl,Flooring,Installer`,
  '6131': `Forestry Worker, Logger; Axeman,Bushman : Crosscutter,Feller,Forest,Tree,Log`,
  '6112': `Fruit Grower; Apple,Berry,Grape,Orhard : Citrus,Picker,Grower,Vineyard`,
  '8275': `Fruit,vege,nut Process. Mach Op; Canning : Food,Syrup,Preserving,Fruit,Vege,Jam`,
  '6113': `Gardener, Nursery Grower; Nursery,Seed : Arborist,Greenhouse,Horticultural,Tree`,
  '2114': `Geologist, Geophysicist; Marine Scientist : Seismologist,Vulcanologist,Oceanographer`,
  '8131': `Glass & Ceramics Kiln Operator; Tile,Clay : Brick Maker,Pottery,Kiln,Porcelain,Mixer`,
  '7321': `Glass Cutter & Finisher; Beveller,Cutter : Etcher,Engraver,Lens Moulder,Slitter`,
  '7122': `Glazier; Auto,Leaded Glass,Leadlight : Mirror Installer,Window Glass Fitter`,
  '8273': `Grain Milling Machine Operator; Cereal : Flour,Grain,Lucerne,Seed,Spice,Wheat`,
  '5141': `Hairdresser, Beautician Or Rel.workr; : Massage Therapist,Weight Loss,Cosmetic`,
  '8323': `Heavy Truck Driver; Articulated,Freight : Milk,Removal,Truck,Vehicle,Concrete`,
  '5121': `Housekeeper; Matron,Hostel Supervisor : Housemaid,Valet,Maid,Prison Matron`,
  '9991': `Housewife \\ Househusband; Mother,Parent : Domestic,Home,House,Father,Widow`,
  '1223': `Human Resources Manager; Training,Labour : Personnel,Development,Employee Relations`,
  '6143': `Hunter, Trapper; Deer Culler,Muttonbirder : Pest Destruction,Rabbiter,Shooter,`,
  '3312': `Insurance Representative; Accident, Life : Assurance,Agent,Adjustor,Surveyor,Clerk`,
  '7313': `Jeweller,precious Met.trade Worker; Paua : Facetor,Gem,Greenstone,Silversmith`,
  '2422': `Judge; Referee Small Claims : Chief Justice`,
  '9151': `Labourer; Builders,Factory,Fitter,General : Road,Rail,Timber,Plasterer,Plumber,Wool`,
  '8281': `Leather & Rel. Products Processor; Pelt : Fellmonger,Hide,Flesher,Dresser,Tanner`,
  '8295': `Leather Goods Assembler; Footwear,Shoe : Shoe Clicker,Cutter,Maker,Shanker,Goods`,
  '7441': `Leather Goods Maker; Boot Repair,Cobbler : Saddler,Harness,Shoe Repairer`,
  '3322': `Legal Or Rel. Business Assoc. Prof; Legal : Articled,Court,Estate,Trust,Conveyancing`,
  '1111': `Legislator; Mayor,Govt Minister : City Councillor,MP,Regional Councillor`,
  '2432': `Librarian Or Related Info Prof; : Information Services Administrator`,
  '4141': `Library, Filing Clerk; Cataloguing Clerk : Compiler,Records Clerk,Registry`,
  '3211': `Life Science Technician; Biology,Ecology : Medical,Phlebotomist,Taxidermist,Water`,
  '8334': `Lifting-truck Operator; Tow Truck : Forklift,Hoist,Straddle,Timber Carrier`,
  '6121': `Livestock Producer; Beef,Farm,Bull,Deer : Stud,Sheep,Goat,Dog,Horse,Ostrich,Pig`,
  '8211': `Machine Tool Operator; Lathe,Metal Tool : Bolt,Spring,Wire,Sharpener,Grinder`,
  '7231': `Machinery Mechanic & Fitter; Agricultural : Aircraft,Vehicle,Refrigeration`,
  '4142': `Mail Carrier, Sorting Clerk; Mail Clerk : Mail Sorter,Post Office,Rural Mail`,
  '2121': `Mathematician, Statistician; Actuary : Epidemiologist,Average Adjuster`,
  '8271': `Meat, Fish Processing Machine Op; Butcher : Chicken,Freezer,Abbattoir,Oyster,Sausage`,
  '2145': `Mechanical Engineer; Industrial,Aircraft : Refrigeration,Heating,Ventilation,Marine`,
  '3115': `Mechanical Engineering Technician; Marine : Quality,Aeronautical,Air,Heat,Tool,Die`,
  '8291': `Mechanical Machinery Assembler; Vehicle : Chassis,Car,Mechanical,Assembly`,
  '2221': `Medical Doctor; GP,Specialist,Surgeon : Paediatrician,Anaesthetist,Radiologist`,
  '3133': `Medical Equipment Controller; Technician : Xray,Hospital,Quality,Radio,Diagnostic`,
  '9121': `Messenger, Doorkeeper; Porter, Courier : Milk,Paper,Pizza Delivery`,
  '8124': `Metal Drawer & Extruder; Manipulator : Metal Rolling,Wire Drawer,Normaliser`,
  '8222': `Metal Finisher, Plater, Coater; Anodiser : Electro,Galviniser,Polisher,Burnisher`,
  '8122': `Metal Melter, Caster; Rod Casting,Fettler : Foundry,Iron,steel,Sandblaster`,
  '7211': `Metal Moulder; Brass Founder,Coremaker : Foundry Moulder`,
  '8123': `Metal Welder; Argon,Brazer,Electric Arc : Flame,Gas,Lead,Oxyacetylene,Spot Welder`,
  '8293': `Metal,rubber &plastic Prods Assemb; Vinyl : Plastic,Rubber,Metal,Cassette,Assembler`,
  '2112': `Meteorologist; Atmospheric Scientist : Weather Forecaster,Climatologist`,
  '2212': `Microbiologist Or Related Prof; Medical : Biochemist,Forensic,Research,Virologist`,
  '8112': `Mineral Ore, Stone Treat Plant Op; Lime : Quarry,Screen,Crusher,Grinder,Mineral`,
  '3117': `Mining & Metallurgical Technician`,
  '2147': `Mining Engineer, Metallurgist; Assayer : Colliery,Metal Scientist,Coal`,
  '8111': `Mining Plant Operator; Bentonite,Gravel : Gold,Copper,Silver,Gravel,Scheelite,Mine`,
  '6122': `Mixed Livestock Producer; Farmer,Farm : Farm Worker, Farm Manager`,
  '8331': `Motorised Farm Machinery Operator; Lime : Agricultural,Farm,Tractor,Weed,Plough`,
  '7312': `Musical Instrument Maker, Tuner; Piano : Tuner,Musical Instrument Repairer`,
  '3371': `Non-ordained Religious Assoc. Prof; Bible : Christian,Missionary,Regilious,Yoga,Nun`,
  '9999': `Not Obtainable; Not Stated,Not Supplied : N/A,Not Specified`,
  '2231': `Nursing & Midwifery Professional; Matron : Kumau Mahi Whanui,Nehi Mahi Whanui`,
  '3231': `Nursing Associate Professional; Enrolled : Community,Unregistered,Psychiatric,Aid`,
  '9970': `Occupation Unidentified/inadequate; :`,
  '4144': `Office Clerk; Clerical,Office Clerk : Payroll,Research,Addressing Machine,`,
  '3221': `Optician; Optical Assistant,Dispenser : Spectacles`,
  '8121': `Ore Smelting & Refining Furnace Op; Ingot : Forge,Cupola,Die Press,Annealer,Hammer`,
  '6126': `Other Agricultural Worker; Cattle,Dairy : Horse,Shearer,Stable,Stock,Wool,Herdsman`,
  '2413': `Other Business Professional; Advisor : Market Research,Financial,Investment`,
  '8154': `Other Chemical Processing Plant Op; : Battery,Furnaceman,Gas,Paint,Radioactive`,
  '3119': `Other Engineering Technician; Testing : Quality,Technical,Measures,Weights`,
  '3319': `Other Finance,sales Associate Prof; : Stock and Station Agent`,
  '8132': `Other Glass & Ceramics Worker; Bottle : Ceramic,Fibreglass,Blower,Mirror,Flanger`,
  '2446': `Other Government Professional; Diplomatic : Consular,Embassy,Foreign,Commissioner`,
  '3226': `Other Health Associate Professionl; : Dental,Hearing Aid,Family Planning,`,
  '2226': `Other Health Professional; Optometrist : Oculist,Opthalmic,Optician,Orthoptist`,
  '2423': `Other Legal Professional; Coroner,Jurist : Arbitrator,Mediator,Negotiator,Patent`,
  '5154': `Other Protective Service Worker; Escort : Patrolman,Security,Guard,Bouncer,Warden`,
  '8232': `Other Rubber, Plastic Prod Mach Op; : Formica,Moulding,Millman,Laminator`,
  '1229': `Other Specialised Manager; Office : Clerical,Chief Clerk`,
  '8265': `Other Textile Products Machine Op; Fibre : Wool,Scourer,Grader,Comber,Gill Box,`,
  '9995': `Overseas Visitor`,
  '9141': `Packer, Freight Handler; Baggage,Boat : Cargo,Furniture,General,Warehouse,Meat`,
  '7124': `Painter & Paperhanger; Automobile,Ship : Spray Painter,Road Marker,Sign Writer`,
  '8251': `Paper & Paper Products Mach Op; Cardboard : Guillotine,Envelope,Forme Maker,Cutting`,
  '8142': `Paper Pulp Preparation Plant Op; Beater : Pulp,Wood Grinder,Digestor,Bleacher`,
  '8143': `Papermaking Plant Operator; Paper Mill : Blendman,Paper,Strawboard,Pulp,Wet End`,
  '5131': `Personal Care Worker; Paramedic,Dentist : Home Aide,Hospital Aide,Psychopaedic`,
  '2412': `Personnel Professional; EEO Advisor,staff : Industrial Relations,Human Resources,`,
  '3225': `Pharmaceutical Assistant; Dispenser : Pharmacy,Hospital,Retail`,
  '8221': `Pharmaceutical Products Mach Op; Soap : Cosmetic,Pharmacy,Supervisor,Toiletry`,
  '2224': `Pharmacist; Retail,Hospital,Community : Health,Dispensing,Chemist,Health Service`,
  '2443': `Philologist,translator,interpreter; : Linguist,Language,Transcriber`,
  '8223': `Photographic Products Machine Op; Minilab : Film,Photo,Photographic,Darkroom,Printer`,
  '3131': `Photographr & Recordng Equip Cntrl; Video : sound,operator,film,Cameraman,Television`,
  '3111': `Physical Science Technician; Field Trials : Laboratory,Research,Assistant,Technical`,
  '2111': `Physicist, Astronomer; Biophysicist : Nuclear,Physical Scientist,Radio`,
  '3223': `Physiotherapist; Limb,Chiropractor : Orthotist,Podiatrist,Rehabilitation`,
  '7121': `Plasterer; Dry Wall,Fibrous Plaster,Gib : Stucco,Solid,Interior,Gib Stopper`,
  '7123': `Plumber; Kaiwhakarerewai, Maintenance : Kaiwhakauru Taputapu Wai`,
  '5152': `Police; Constable,Traffic Officer,Warden : Policeman,Policewoman,Road Safety`,
  '6123': `Poultry Producer; Chicken Farm,Pheasant : Hatchery,Turkey,Goose,Duck,Egg,Sexer`,
  '8161': `Power Generating Plant Operator; : Boilerman,Electric,Hydroelectric,Steam`,
  '9997': `Pre-school Child; Child,Infant,Baby, : Toddler,Minor,Juvenile,School Child`,
  '7311': `Precision Inst. Maker & Repairer; Watch : Camera,Gun,Horologist,Optical,Surgical`,
  '2331': `Primary Teaching Professional; Teacher : School,Correspondence,Intermediate`,
  '7333': `Printing Engraver & Etcher; Cameraman : Photo Engraver, Retoucher,Printing`,
  '7331': `Printing Trades Worker; Typesetter,Block : Letterpress,Pre-press,Lithographic`,
  '5153': `Prison Guard; Guard,Officer,Warden,Warder : Apiha Whakatika Whakaora Mauhere,Pouawhi`,
  '9998': `Prison Inmate`,
  '1221': `Production & Operation Manager; Education : Factory,Transport,Construction,Forest`,
  '4132': `Production Clerk; Schedule,Materials : Coordinating Clerk,Planner,Controller`,
  '2444': `Psychologist; Behavioural,Psychotherapist : Psychology,Counsel,Development,Therapist`,
  '7243': `Radio & Television Servicer; Aerial,Radar : TV Repair,Installer,Audio`,
  '3367': `Radio,television,other Announcer; DJ : Broadcaster,Presenter,Commentator,News`,
  '8311': `Railway Engine Driver; Cable Car,Train : Locomotive,Chairlift,Railway`,
  '3313': `Real Estate Agent; Leasing,Property : Consultant,Sales,Residential,Developer`,
  '4221': `Receptionist, Information Clerk; Hospital : Tourist,Travel,Medical,Dental,Patient`,
  '9131': `Refuse Collector Or Rel. Labourer; Park : Council, Garbage,Recycler,Road Sweeper`,
  '2451': `Religious Professional; Minister,Chaplin : Rabbi,Clergy,Pastor,Vicar,Priest,Army`,
  '1228': `Research & Development Manager; : Quality Assurance`,
  '9993': `Retired; Pensioner,Superannuitant : Widow`,
  '3151': `Safety & Health Inspector; Accident,Meat : Officer,Quality,Controller,SPCA,Pest`,
  '1224': `Sales & Marketing Manager; Coordinator : Travel,District,Export,National,`,
  '5211': `Salesperson, Demonstrator; Retail,Tyres : Book,Amway,Car,Attendant,Sales`,
  '7224': `Saw Doctor; Saw Setter,Saw Sharpener : Saw Repairer`,
  '8141': `Sawmill Or Rel. Wood Processing Op; Log : Post,Planer,Sawyer,Timber,Chipper,Docker`,
  '3362': `Sculptor,painter Or Related Artist; Art : Cartoonist,Tattooist,Wood Carver,Artist`,
  '2321': `Secondary Teaching Professional; College : High School,Correspondence,Teacher,Tutor`,
  '4114': `Secretary; Farm,Executive Assistant,PA : Legal,Personal,School,Correspondence`,
  '3311': `Securities & Finance Dealer,broker; : Stocks,Sharebroker,Futures,Equity`,
  '1131': `Senior Business Administrator; President : Managing Director,Chief Executive,CEO`,
  '1121': `Senior Government Administrator; Central : Local,Diplomatic,Public Service,Civil`,
  '8263': `Sewing, Embroidering Mach. Op; Sewing : Garment,Upholstery,Seamstress,Curtain`,
  '7212': `Sheet-metal Worker; Aircraft,Auto Body : Boiler,Coach,Panel Beater, Shipwright`,
  '8341': `Ships' Deck Crew Or Rel. Worker; Seaman : Ferry,Merchant,Crew,Jet Boat,Charter`,
  '3142': `Ships' Deck Officer & Pilot; Master,Mate : Harbour,Captain,Boatswain,Bosun,Cabin`,
  '3141': `Ships' Engineer; Marine,Sea,Naval :`,
  '9992': `Sickness Beneficiary; ACC,Illness,WINZ : Benefit,Social Welfare`,
  '2442': `Social Scientist; Historian,Sociologist : Environmental,Policy Analyst,Geographer`,
  '3341': `Social Work Associate Professional; Youth : Case,Community,Family,Probation,Prison`,
  '2341': `Special Education Teaching Prof; English : IHC,Remedial,Therapist,Speech,Language`,
  '1141': `Special-interest Org.administrator; Union : Sport,Political,Recreation,Community`,
  '8261': `Spinning, Winding Machine Operator; Fibre : Rope,Twine,Spinner,Yarn,Wool,Textile`,
  '4122': `Statistical, Finance Clerk; Brokerage : Census,Credit,Finance,Mortgage,Telephone`,
  '3324': `Statistical,mathematical Ass. Prof; : Contracts,Efficiency,Organisation,Study`,
  '8153': `Still & Reactor Operator; Acetylene,Oil : Petroleum,Refinery,Natural Gas`,
  '4131': `Stock Clerk; Bulk Store,Customs,Dispatch : Freight,Inventory,Purchasing,Warehouse`,
  '5221': `Street Vendor; Amusement,Fairground : Bread,Ice Cream,Newsagent,Milk Vendor`,
  '9994': `Student; Intermediate : Training,Polytechnic,University,Primary`,
  '8276': `Sugar Process, Refining Mach Op; : Confectionary,Refining,Processor`,
  '1226': `Supply & Distribution Manager; Wholesaler : Exporter,Retailer,Restauranteur,Caterer`,
  '7431': `Tailor & Dressmaker; Bespoke,Clothing : Dress Maker,Garment,Leather,Wardrobe`,
  '8277': `Tea,coffee,cocoa Machine Operator; Coffee : Chocolate Maker,Blender,Maltster,Vinegar`,
  '3315': `Technical & Commercial Sales Rep; : Advertising,Company,Representative,Sales`,
  '4222': `Telephone Switchboard Operator; PABX : Telephonist,Tolls,Call Centre,Answering`,
  '4212': `Teller Or Other Counter Clerk; Bank Clerk : Currency Exhange,Bank,Credit Support`,
  '2311': `Tertiary Teaching Professional; Lecturer : University,Polytechnic,Tutor,Instructor`,
  '8264': `Textile Dyeing, Cleaning Mach Op; Carpet : Bleacher,Dry Cleaning,Garment,Clothing`,
  '8278': `Tobacco Prods Process. Mach Op; Cigarette : Cigar,Tabacco Grader,`,
  '7222': `Tool Or Pattern Maker,metal Marker; : Toolmaker,Jig,Pattern,Die Cutter, Die`,
  '4133': `Transport Clerk; Inspector,Conductor : Railway,Shipping,Controller,Dispatcher`,
  '5111': `Travel Attendant; Flight Attendant,Purser : Steward,Stewardess,Hostess,Attendant`,
  '3314': `Travel Consultant, Organiser; Reservation : Airline Clerk,Booking,Agent,Wholesaler`,
  '5112': `Travel Guide; Safari,Adventure,Tour Guide : Sightseeing,Scenic Tour,Meseum,Guide`,
  '4111': `Typist Or Word Processor Operator; : Audio,Bank,Hansard,Medical,Stenographer`,
  '8231': `Tyre Making Vulcanising Mach Op; Retread : Mould Press,Fitter,Vulcaniser,Moulder`,
  '5143': `Undertaker, Embalmer; Funeral,Mortician : Crematorium,Funeral Director`,
  '8412': `Underwater Worker; Construction,Diver : Police Diver,Salvage,General`,
  [ACC_OCCUPATION_CODE_UNEMPLOYED]: `Unemployed; WINZ,Social Welfare : Beneficiary,Not working`,
  '7432': `Upholsterer Or Related Worker; Automobile : Awning,Blind,Canvas,Furniture,Vehicle`,
  '2223': `Veterinarian; Officer Agriculture : Veterinary Surgeon,Animal Doctor,Vet`,
  '3224': `Veterinary Assistant; Nurse,Receptionist : Herd Tester,Brucellosis,Animal`,
  '5123': `Waiter, Bartender; Barperson,Caf¿,Canteen : Catering,Usher,Takeaway,Restaurant`,
  '8262': `Weaving, Knitting Machine Operator; Braid : Carpet,Crochet,Hosiery,Loom,Knitting,Rug`,
  '8113': `Well Driller, Borer & Rel. Worker; Borer : Cable,Derrick,Rotary,Roughneck,Sinker`,
  '8294': `Wood &rel Material Prods Assemblr; Fencer : Basket,Wicker,Cane,Furniture,Toys`,
  '8241': `Wood Products Machine Operator; Carpenter : Joinery,Timber,Woodworking,Precision`,
  '8242': `Wood Treater; Preservation Plant,Dipper : Timber Treatment,Wood,Seasoner,Kiln`,
  '9980': `Workers Not Reporting Any Descrip; : N/A,Not Specified,Not Stated`,
};
export type AccOccupationCode = keyof typeof ACC_OCCUPATION_MAP;

export interface IACCOccupationDisplayEntry {
  code: string;
  displayName: string;
  searchTerms: string[];
}

export const ACC_OCCUPATION_ENTRIES = parseOccupationEntries();

function parseOccupationEntries(): IACCOccupationDisplayEntry[] {
  const entries: IACCOccupationDisplayEntry[] = [];

  Object.entries(ACC_OCCUPATION_MAP).forEach(([code, occupationString]) => {
    const semicolonParts = occupationString.split(';');
    const mainTitle = semicolonParts[0].trim();

    const allSearchTerms: string[] = [];

    if (semicolonParts.length > 1) {
      const afterSemicolon = semicolonParts[1];
      const colonParts = afterSemicolon.split(':');

      colonParts.forEach((part) => {
        const searchTerms = part
          .split(',')
          .map((term) => term.trim())
          .filter((term) => term.length > 0);
        allSearchTerms.push(...searchTerms);
      });
    }

    entries.push({
      code,
      displayName: mainTitle,
      searchTerms: [mainTitle, ...allSearchTerms],
    });
  });

  return entries.sort((a, b) => a.displayName.localeCompare(b.displayName));
}

export const ACC_DIAGNOSIS_CODE_SYSTEM_MAP: Record<string, string> = {
  '1': 'Read Code',
  '2': 'ICD 9',
  '3': 'ICD 10',
};
export type AccDiagnosisCodeSystemCode =
  keyof typeof ACC_DIAGNOSIS_CODE_SYSTEM_MAP;
